import React from "react"
import { MultiStepFlowContainer } from "../../Components/MultiStepFlow"
import { Paragraph } from "../../Components/Paragraph"
import { StudentActivities } from "../../constants/stepRegistry"
import { useOutletContextPlan } from "../../hooks/useOutletContextPlan"
import { useNavigate } from "react-router-dom"
import { isStepLocked } from "../../lib/plan"
import { PLAN_STATUS } from "../../constants/planStatus"
import LockedStep from "../../Components/LockedStep"
import { MoreInfoVideoModal } from "../../Components/MoreInfoVideoModal"
import {
  INVITE_STUDENT_RESOURCE_URL,
  SIT_WITH_STUDENT_RESOURCE_URL,
} from "../../constants/resources"

/**
 * SitWithStudent
 *
 * Multi-step flow for scheduling and documenting a session with the student.
 * This is step 3 of the setup checklist.
 */
const SitWithStudent = () => {
  const { student, plan, currentStep } = useOutletContextPlan()
  const navigate = useNavigate()
  const steps = [
    {
      id: "sit-with-student",
      encouragement: "✏️",
      encouragementClassName: "text-3xl",
      title: "Complete Student Activities",
      renderCustomContent: () => {
        return (
          <div className="mx-auto flex max-w-xl flex-col items-center justify-center gap-2 text-center">
            <Paragraph>You're are about to embark on a meaningful journey!</Paragraph>
            <Paragraph>
              These four Student Activities lay the foundation for a strong Mentor Circle Plan.
            </Paragraph>
            <Paragraph>
              <MoreInfoVideoModal
                src={SIT_WITH_STUDENT_RESOURCE_URL}
                text=""
                postText="How the Student Activities Work"
                title="Sitting With Your Student"
                textClassName="text-brand no-underline"
              />
            </Paragraph>

            <div className="mx-auto mt-4 flex max-w-md flex-col gap-8">
              {StudentActivities.map((activity, index) => (
                <Activity key={index} activity={activity} />
              ))}
            </div>
          </div>
        )
      },
    },
  ]

  const handleComplete = (values, stepId) => {
    if (!plan?.token) {
      console.error("Plan token is missing")
      return
    }
    navigate(`/plan/${plan.token}/activities`)
  }

  if (isStepLocked(PLAN_STATUS.SIT_WITH_STUDENT, currentStep)) {
    return <LockedStep />
  }

  return (
    <MultiStepFlowContainer
      steps={steps}
      initialValues={{}}
      onBack={() => {
        navigate(`/plan/${plan?.token}/checklist`)
        return true
      }}
      alwaysShowBackButton={true}
      onComplete={handleComplete}
      showProgress={false}
      completeButtonText="Let's get started!"
      containerClassName="max-w-md"
      fieldWidth="w-64 mx-auto"
      fieldContainerClassName="flex flex-col items-center"
    />
  )
}

const Activity = ({ activity }) => {
  return (
    <div className="flex flex-row items-start justify-start gap-4 text-left">
      <img className="h-16 w-16" src={activity.image} alt={activity.name} />
      <div className="flex flex-col items-start justify-start">
        <div className="mb-2 flex flex-col justify-start sm:mb-0 sm:flex-row sm:items-center sm:gap-2">
          <div className="text-lg font-bold">{activity.altTitle ?? activity.title}</div>
          <div className="text-sm text-gray-500">{activity.description}</div>
        </div>
        <div className="text-sm text-gray-600">{activity.details}</div>
      </div>
    </div>
  )
}
export default SitWithStudent
